import { connect } from 'react-redux';

import SignUp from './SignUp';
import { selectors as userSelectors } from '../../dux/user';

const mapStateToProps = (state) => ({
  user: userSelectors.getIdentityState(state),
  isAuthenticated: userSelectors.isAuthenticated(state),
  needsEmailVerification: userSelectors.needsEmailVerification(state),
  needsOrg: userSelectors.needsOrganization(state),
});

export default connect(mapStateToProps, null)(SignUp);
